/* Yorkshire Home Interiors theme — vanilla JS, no dependencies. */
(() => {
  const routes = (window.theme && window.theme.routes) || {};
  const root = routes.root || '/';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const format = (window.theme && window.theme.moneyFormat) || '£{{amount}}';
    const value = Number(cents) / 100;
    const withDelimiters = (number, decimals, thousands = ',', decimal = '.') => {
      const fixed = number.toFixed(decimals).split('.');
      fixed[0] = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fixed.join(decimal);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0);
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        default: return withDelimiters(value, 2);
      }
    }).replace(/[.,]00(?=\D*$)/, '');
  }

  /* ---------- Scroll lock ---------- */
  let lockCount = 0;
  const lockScroll = () => { lockCount += 1; document.body.style.overflow = 'hidden'; };
  const unlockScroll = () => { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.style.overflow = ''; };

  /* ---------- Header: shadow, announcement rotator, mobile menu ---------- */
  function initHeader() {
    const header = $('[data-site-header]');
    if (!header) return;

    const onScroll = () => header.classList.toggle('shadow-md', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const announcement = $('[data-announcement]', header);
    if (announcement) {
      let messages = [];
      try { messages = JSON.parse(announcement.dataset.messages || '[]'); } catch (e) { messages = []; }
      if (messages.length > 1) {
        let index = 0;
        setInterval(() => {
          index = (index + 1) % messages.length;
          announcement.style.opacity = '0';
          setTimeout(() => { announcement.textContent = messages[index]; announcement.style.opacity = '1'; }, 250);
        }, 4000);
      }
    }

    const toggle = $('[data-mobile-menu-toggle]', header);
    const menu = $('[data-mobile-menu]', header);
    if (!toggle || !menu) return;
    const setOpen = (open) => {
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      $('[data-icon-open]', toggle).hidden = open;
      $('[data-icon-close]', toggle).hidden = !open;
    };
    toggle.addEventListener('click', () => setOpen(menu.hidden));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) setOpen(false); });
    document.addEventListener('click', (e) => { if (!menu.hidden && !header.contains(e.target)) setOpen(false); });
    window.matchMedia('(min-width: 1024px)').addEventListener('change', (e) => { if (e.matches) setOpen(false); });
  }

  /* ---------- Hero slider ---------- */
  function initHero(hero) {
    const slides = $$('[data-hero-slide]', hero);
    const dots = $$('[data-hero-dot]', hero);
    if (slides.length < 2) return;
    let current = 0;
    const interval = Number(hero.dataset.interval) || 6000;

    const show = (next) => {
      current = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.classList.toggle('opacity-100', active);
        slide.classList.toggle('scale-100', active);
        slide.classList.toggle('opacity-0', !active);
        slide.classList.toggle('scale-[1.02]', !active);
        slide.classList.toggle('pointer-events-none', !active);
        slide.setAttribute('aria-hidden', String(!active));
        if (active) $$('img[loading="lazy"]', slide).forEach((img) => { img.loading = 'eager'; });
      });
      dots.forEach((dot, i) => {
        const active = i === current;
        dot.classList.toggle('w-8', active);
        dot.classList.toggle('bg-wheat', active);
        dot.classList.toggle('w-2', !active);
        dot.classList.toggle('bg-white/50', !active);
        dot.classList.toggle('hover:bg-white/80', !active);
      });
    };

    let timer = setInterval(() => show(current + 1), interval);
    const restart = () => { clearInterval(timer); timer = setInterval(() => show(current + 1), interval); };

    $('[data-hero-prev]', hero)?.addEventListener('click', () => { show(current - 1); restart(); });
    $('[data-hero-next]', hero)?.addEventListener('click', () => { show(current + 1); restart(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.heroDot)); restart(); }));

    let touchX = null;
    hero.addEventListener('touchstart', (e) => { touchX = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      if (touchX === null) return;
      const delta = e.changedTouches[0].clientX - touchX;
      if (Math.abs(delta) > 50) { show(current + (delta < 0 ? 1 : -1)); restart(); }
      touchX = null;
    });

    // Re-initialise when edited in the theme editor.
    hero.addEventListener('shopify:block:select', (e) => {
      const index = slides.indexOf(e.target.closest('[data-hero-slide]'));
      if (index >= 0) { show(index); clearInterval(timer); }
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message) {
    const el = $('[data-toast]');
    if (!el) return;
    $('[data-toast-message]', el).textContent = message;
    el.classList.remove('opacity-0', 'translate-y-4', 'scale-95');
    el.classList.add('opacity-100', 'translate-y-0', 'scale-100');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      el.classList.add('opacity-0', 'translate-y-4', 'scale-95');
      el.classList.remove('opacity-100', 'translate-y-0', 'scale-100');
    }, 2500);
  }

  /* ---------- Cart ---------- */
  const cart = {
    isOpen: false,

    drawer() { return $('[data-cart-drawer]'); },

    applyState() {
      const drawer = this.drawer();
      if (!drawer) return;
      const backdrop = $('[data-cart-backdrop]', drawer);
      const panel = $('[data-cart-panel]', drawer);
      drawer.classList.toggle('pointer-events-auto', this.isOpen);
      drawer.classList.toggle('pointer-events-none', !this.isOpen);
      backdrop.classList.toggle('bg-charcoal/60', this.isOpen);
      backdrop.classList.toggle('backdrop-blur-sm', this.isOpen);
      backdrop.classList.toggle('opacity-100', this.isOpen);
      backdrop.classList.toggle('bg-charcoal/0', !this.isOpen);
      backdrop.classList.toggle('opacity-0', !this.isOpen);
      panel.classList.toggle('translate-x-0', this.isOpen);
      panel.classList.toggle('translate-x-full', !this.isOpen);
      panel.toggleAttribute('inert', !this.isOpen);
    },

    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.applyState();
      lockScroll();
      setTimeout(() => $('[data-cart-panel] [data-cart-close]')?.focus(), 50);
    },

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.applyState();
      unlockScroll();
    },

    sectionIds() {
      const ids = ['cart-drawer'];
      $$('[data-cart-section]').forEach((el) => ids.push(el.dataset.cartSection));
      return ids;
    },

    renderSections(sections) {
      if (!sections) return;
      Object.entries(sections).forEach(([id, html]) => {
        const target = document.getElementById(`shopify-section-${id}`);
        if (!target || !html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = doc.getElementById(`shopify-section-${id}`);
        target.innerHTML = source ? source.innerHTML : html;
      });
      this.applyState();
    },

    async refreshCount() {
      const res = await fetch(`${routes.cart || '/cart'}.js`, { headers: { Accept: 'application/json' } });
      const data = await res.json();
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = data.item_count;
        el.classList.toggle('hidden', data.item_count === 0);
      });
      $$('[data-cart-count-plain]').forEach((el) => { el.textContent = data.item_count; });
      return data;
    },

    async add(items, title) {
      const res = await fetch(`${routes.cartAdd || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: this.sectionIds().join(','), sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to basket');
      this.renderSections(data.sections);
      await this.refreshCount();
      this.open();
      toast(`${title || 'Item'} added to basket`);
    },

    async change(key, quantity) {
      const res = await fetch(`${routes.cartChange || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: this.sectionIds().join(','), sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not update basket');
      this.renderSections(data.sections);
      await this.refreshCount();
    },
  };

  function initCart() {
    cart.applyState();

    document.addEventListener('click', async (e) => {
      const opener = e.target.closest('[data-cart-open]');
      if (opener) {
        e.preventDefault();
        cart.open();
        return;
      }

      if (e.target.closest('[data-cart-close]')) {
        cart.close();
        return;
      }

      const addButton = e.target.closest('[data-add-to-cart]');
      if (addButton) {
        e.preventDefault();
        if (addButton.disabled) return;
        addButton.disabled = true;
        try {
          await cart.add([{ id: Number(addButton.dataset.variantId), quantity: 1 }], addButton.dataset.productTitle);
          if (addButton.hasAttribute('data-quick-view-close-after')) closeQuickView();
        } catch (err) {
          toast(err.message);
        } finally {
          addButton.disabled = false;
        }
        return;
      }

      const changeButton = e.target.closest('[data-cart-change]');
      if (changeButton) {
        e.preventDefault();
        changeButton.disabled = true;
        try {
          await cart.change(changeButton.dataset.key, Math.max(0, Number(changeButton.dataset.quantity)));
        } catch (err) {
          toast(err.message);
          changeButton.disabled = false;
        }
      }
    });

    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') cart.close(); });

    $$('[data-product-form]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const button = $('[data-add-button]', form);
        const formData = new FormData(form);
        button.disabled = true;
        try {
          await cart.add([{ id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) }], button.dataset.productTitle);
        } catch (err) {
          toast(err.message);
        } finally {
          button.disabled = false;
        }
      });
    });
  }

  /* ---------- Quick view ---------- */
  let quickViewEl = null;
  let quickViewTrigger = null;

  function closeQuickView() {
    if (!quickViewEl) return;
    quickViewEl.remove();
    quickViewEl = null;
    unlockScroll();
    quickViewTrigger?.focus();
  }

  function initQuickView() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-quick-view-open]');
      if (trigger) {
        const template = $('template[data-quick-view-template]', trigger.closest('article'));
        if (!template) return;
        closeQuickView();
        quickViewTrigger = trigger;
        quickViewEl = template.content.firstElementChild.cloneNode(true);
        document.body.appendChild(quickViewEl);
        lockScroll();
        $('[data-quick-view-close]', quickViewEl)?.focus();
        return;
      }
      if (!quickViewEl) return;
      if (e.target === quickViewEl || e.target.closest('[data-quick-view-close]')) closeQuickView();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeQuickView(); });
  }

  /* ---------- Collection filters ---------- */
  function initCollectionFilters() {
    const panel = $('[data-collection-filters]');
    if (!panel) return;

    const handle = panel.dataset.collectionHandle;
    const collectionUrl = `${root.replace(/\/$/, '')}/collections/${handle}`;
    const roomSelect = $('[data-filter-room]', panel);
    const sortSelect = $('[data-filter-sort]', panel);
    const categorySelect = $('[data-filter-category]', panel);
    const queryInput = $('[data-filter-query]', panel);

    const buildUrl = (base, room, sort) => {
      let url = base.replace(/\/$/, '');
      if (room) url += `/${room}`;
      if (sort && sort !== 'manual') url += `?sort_by=${encodeURIComponent(sort)}`;
      return url;
    };

    categorySelect?.addEventListener('change', () => {
      window.location.href = buildUrl(categorySelect.value, roomSelect?.value, sortSelect?.value);
    });
    roomSelect?.addEventListener('change', () => {
      window.location.href = buildUrl(collectionUrl, roomSelect.value, sortSelect?.value);
    });
    sortSelect?.addEventListener('change', () => {
      window.location.href = buildUrl(collectionUrl, roomSelect?.value, sortSelect.value);
    });

    if (queryInput) {
      const items = $$('[data-product-item]');
      const count = $('[data-count-value]');
      const countWrap = $('[data-product-count]');
      const empty = $('[data-filter-empty]');
      const params = new URLSearchParams(window.location.search);
      const apply = () => {
        const term = queryInput.value.trim().toLowerCase();
        let visible = 0;
        items.forEach((item) => {
          const match = !term || item.dataset.title.includes(term);
          item.hidden = !match;
          if (match) visible += 1;
        });
        if (count) {
          count.textContent = term ? visible : countWrap.dataset.total;
          countWrap.lastChild.textContent = ` product${(term ? visible : Number(countWrap.dataset.total)) === 1 ? '' : 's'}`;
        }
        empty?.classList.toggle('hidden', visible > 0 || !term);
      };
      queryInput.addEventListener('input', apply);
      queryInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && queryInput.value.trim()) {
          window.location.href = `${routes.search || '/search'}?q=${encodeURIComponent(queryInput.value.trim())}&type=product&options[prefix]=last`;
        }
      });
      if (params.get('q')) { queryInput.value = params.get('q'); apply(); }
    }
  }

  /* ---------- Product page: gallery + variants ---------- */
  function initProduct() {
    const section = $('[data-product-section]');
    if (!section) return;

    const slides = $$('[data-gallery-slide]', section);
    const thumbs = $$('[data-gallery-thumb]', section);
    const showMedia = (index) => {
      slides.forEach((slide, i) => slide.classList.toggle('hidden', i !== index));
      thumbs.forEach((thumb, i) => {
        const active = i === index;
        ['ring-2', 'ring-forest', 'ring-offset-2'].forEach((c) => thumb.classList.toggle(c, active));
        ['opacity-70', 'hover:opacity-100'].forEach((c) => thumb.classList.toggle(c, !active));
      });
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(Number(thumb.dataset.galleryThumb))));

    const variantsJson = $('[data-product-variants]', section);
    if (!variantsJson) return;
    const variants = JSON.parse(variantsJson.textContent);
    const selects = $$('[data-option-index]', section);
    const idInput = $('[data-variant-input]', section);
    const button = $('[data-add-button]', section);
    const price = $('[data-price]', section);
    const compare = $('[data-compare-price]', section);

    selects.forEach((select) => select.addEventListener('change', () => {
      const values = selects.map((s) => s.value);
      const variant = variants.find((v) => v.options.every((opt, i) => opt === values[i]));
      if (!variant) {
        button.disabled = true;
        button.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      price.textContent = formatMoney(variant.price);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      compare.classList.toggle('hidden', !onSale);
      if (onSale) compare.textContent = formatMoney(variant.compare_at_price);
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to basket' : 'Sold out';
      if (variant.featured_media) {
        const slideIndex = slides.findIndex((s) => Number(s.dataset.mediaId) === variant.featured_media.id);
        if (slideIndex >= 0) showMedia(slideIndex);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }));
  }

  /* ---------- Gallery lightbox ---------- */
  function initLightbox() {
    const lightbox = $('[data-lightbox]');
    if (!lightbox) return;
    const image = $('[data-lightbox-image]', lightbox);
    let trigger = null;

    const close = () => {
      if (lightbox.hidden) return;
      lightbox.hidden = true;
      image.src = '';
      unlockScroll();
      trigger?.focus();
    };

    $$('[data-lightbox-src]').forEach((button) => {
      button.addEventListener('click', () => {
        trigger = button;
        image.src = button.dataset.lightboxSrc;
        image.alt = button.dataset.lightboxTitle || '';
        lightbox.setAttribute('aria-label', button.dataset.lightboxTitle || 'Gallery preview');
        lightbox.hidden = false;
        lockScroll();
        $('[data-lightbox-close]', lightbox).focus();
      });
    });
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox || e.target.closest('[data-lightbox-close]')) close();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    const items = $$('[data-reveal]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    items.forEach((el) => observer.observe(el));
  }

  /* ---------- Contact: prefill enquiry from ?product= ---------- */
  async function initContactPrefill() {
    const message = $('[data-contact-message]');
    if (!message || message.value.trim()) return;
    const handle = new URLSearchParams(window.location.search).get('product');
    if (!handle) return;
    let title = handle.replace(/-/g, ' ');
    try {
      const res = await fetch(`${root.replace(/\/$/, '')}/products/${encodeURIComponent(handle)}.js`);
      if (res.ok) title = (await res.json()).title;
    } catch (e) { /* keep handle-based title */ }
    message.value = `Hello, I'd like to enquire about the ${title}.\n\n`;
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    $$('[data-hero]').forEach(initHero);
    initCart();
    initQuickView();
    initCollectionFilters();
    initProduct();
    initLightbox();
    initReveal();
    initContactPrefill();
  });

  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-hero]', e.target).forEach(initHero);
    initReveal();
    initLightbox();
  });
})();
